import { BaseDto } from './base.dto';

export class OrderStatusDto extends BaseDto {
  name: string;
  sequence: number;
}
